<div class="document-wrapper">
  <app-document-viewer [isDataEntry]="true"
                       (escalateDataEntry)="showEscalationDialog()">
  </app-document-viewer>

  <app-intake-document-form *ngIf="!isGrid"></app-intake-document-form>
</div>
